import React from 'react'
import { Line } from 'react-chartjs-2'

export default function LineGraph(props) {
  const {
    datasets,
    labels,
    width,
    height,
    legend,
    hideLegend,
    title
  } = props?.graph
  const data = {
    labels,
    datasets: datasets.map(dataset => {
      return {
        label: dataset.label,
        borderWidth: dataset.borderWidth,
        fill: dataset.fill,
        pointRadius: dataset.pointRadius,
        pointHoverRadius: dataset.pointRadius + 1,
        steppedLine: dataset.steppedLine,
        lineTension: dataset.lineTension,
        data: dataset.data.map(data => {
          return data?.data
        }),
        backgroundColor: dataset.data.map(data => {
          return data?.backgroundColor
        }),
        borderColor: dataset.data.map(data => {
          return data?.borderColor
        }),
        hoverBackgroundColor: dataset.data.map(data => {
          return data?.hoverBackgroundColor
        }),
        hoverBorderColor: dataset.data.map(data => {
          return data?.hoverBorderColor
        })
      }
    })
  }
  const options = {
    title: {
      display: true,
      text: title,
      fontSize: 20
    },
    legend: {
      display: !hideLegend,
      position: legend
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    maintainAspectRatio: false
  }

  return <Line data={data} width={width} height={height} options={options} />
}
